export default "__VITE_ASSET__tjC_EON7__"